import adminCommissionSettlements from "./admin-commission-settlements.json";
import adminCommissions from "./admin-commissions.json";
import adminMerchantManagement from "./admin-merchant-management.json";
import blacklist from "./blacklist.json";
import cardBinQuotas from "./card-bin-quotas.json";
import common from "./common.json";
import dashboard from "./dashboard.json";
import emailTemplates from "./email-templates.json";
import invitationCodes from "./invitation-codes.json";
import merchantCommissionSettlements from "./merchant-commission-settlements.json";
import merchantCommissions from "./merchant-commissions.json";
import merchantUsers from "./merchant-users.json";
import physicalCardShip from "./physical-card-ship.json";
import sys from "./sys.json";
import systemConfig from "./system-config.json";
import systemStatements from "./system-statements.json";
import thirdPartyPartners from "./third-party-partners.json";
import userManage from "./user-manage.json";

export default {
	...common,
	...sys,
	...dashboard,
	...invitationCodes,
	...merchantUsers,
	...merchantCommissions,
	...merchantCommissionSettlements,
	...userManage,
	...blacklist,
	...systemConfig,
	...adminCommissions,
	...adminMerchantManagement,
	...adminCommissionSettlements,
	...physicalCardShip,
	...emailTemplates,
	...cardBinQuotas,
	...systemStatements,
	...thirdPartyPartners,
};
